import {BasePanelPage} from "../../../../PanelPage";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {SubscribeThankYouPanelStyle} from "../SubscribeThankYouPanel";
import {Messages} from "../../../../../Messages";
import {SubscriptionCoveragePerk} from "../components/CoverageDescriptionElements";
import {HappyFaceIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {collapseIframe, collapseIframeAndExpandWallet} from "../../../../../widget/misc/WidgetUtils";


@registerStyle(SubscribeThankYouPanelStyle)
export class GiftSubscriptionSuccessPanel extends BasePanelPage {
    getGuidelines() {
        return [
            <SubscriptionCoveragePerk text={Messages.giftSubscriptionSuccessGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.giftSubscriptionSuccessGuideline2}/>,
        ]
    }

    render() {
        const {styleSheet} = this;

        return [
            <HappyFaceIcon className={styleSheet.icon}/>,
            <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                {Messages.giftSubscriptionSuccessTitle}
            </div>,
            <div className={styleSheet.message}>{Messages.giftSubscriptionSuccessText}</div>,
            this.getGuidelines(),
            <MerchantButton onClick={collapseIframe} className={styleSheet.actionButton}>
                {Messages.ok}
            </MerchantButton>,
            <div className={styleSheet.backButton} onClick={collapseIframeAndExpandWallet}>
                {Messages.manageMyAccount}
            </div>
        ];
    }
}
